import { Action } from '@ngrx/store';

export enum ManagerLivePollingActionTypes {
  StartManagerPolling = '[Live] StartDealManager',
  StopManagerPolling = '[Live] StopDealManager'
}

export class ManagerLivePollingStart implements Action {
  public readonly type = ManagerLivePollingActionTypes.StartManagerPolling;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}

export class ManagerLivePollingStop implements Action {
  public readonly type = ManagerLivePollingActionTypes.StopManagerPolling;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}
